import axios from 'axios';

const baseURL = process.env.REACT_APP_ADMIN_API_BASE_URL;
const hostName = process.env.REACT_APP_HOST_NAME;

const adminAxiosInstance = axios.create({
	baseURL,
	headers: {
		host_name: hostName,
		'x-host': hostName,
		'Content-Type': 'application/json',
		'Access-Control-Allow-Credentials': true,
		Accept: 'application/json'
	},
	withCredentials: true
});

export default adminAxiosInstance;
